export enum CellType {
    Text,
    Date,
    DateTime,
    Icon,
    Button
}
